import React from 'react'
import { NavLink } from 'react-router-dom'
import { ReactComponent as SettingsIcon } from 'assets/icons/settings.svg'
import { ROUTES } from 'shared/config/routes'
import s from './HeaderSettingsButton.module.scss'

export default function HeaderSettingsButton() {
	return (
		<NavLink
			to={ROUTES.SETTINGS}
			className={({ isActive }) =>
				`${s.button} ${isActive ? s.button_active : ''}`
			}
			aria-label="Settings"
		>
			<SettingsIcon className={s.icon} />
		</NavLink>
	)
}
